import { PropTypes } from 'react';
import moment from 'moment';

import { getRacesTicketAvailability, racesHaveAvailableCharityTickets, racesHaveTickets } from '../EventHeader/BookNow/helpers';
import { AVAILABLE, COMING_SOON, ENTRY_CLOSED, SOLD_OUT } from '../EventHeader/BookNow/helpers/availabilityTypes';
import { getDiscountLabel, getDistanceLabel, getPriceLabel } from './helpers';

import RaceSummary from './component';

/**
 * Determine the label describing race availability.
 */
const getAvailabilityLabel = (race, availabilityType, startDate) => {
  if (!racesHaveTickets([race])) {
    return null;
  }

  if (moment.utc(startDate) < moment.utc()) {
    return 'Event passed';
  }

  const hasAvailableCharityTickets = racesHaveAvailableCharityTickets([race]);

  switch (availabilityType) {
    case SOLD_OUT:
      return hasAvailableCharityTickets ? 'Sold out, charity places available' : 'Sold out';
    case ENTRY_CLOSED:
      return hasAvailableCharityTickets ? 'Charity places available' : 'Entry Closed';
    case COMING_SOON:
      return hasAvailableCharityTickets ? 'Charity places available' : 'Tickets Coming Soon';
    case AVAILABLE:
    default:
      return hasAvailableCharityTickets ? 'Tickets & charity places available' : 'Tickets available';
  }
};

/**
 * Container to determine presentational state for component.
 */
const RaceSummaryContainer = ({ race, race: { startDate, startTime, title } }) => {
  // Exclude charity tickets from the availability check, sine the UI displays these separately
  const availability = getRacesTicketAvailability([race], t => t.charityTickets !== true).type;
  return RaceSummary({
    // Info
    title,
    startDate,
    startTime,
    distanceLabel: getDistanceLabel(race),

    // Tickets
    availability,
    availabilityLabel: getAvailabilityLabel(race, availability, startDate),
    discount: getDiscountLabel(race),
    priceLabel: getPriceLabel(race, availability),
  });
};

RaceSummaryContainer.propTypes = {
  race: PropTypes.shape({
    startDate: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
};

export default RaceSummaryContainer;



// WEBPACK FOOTER //
// ./app/src/components/RaceSummary/container.js